/**
 * Simple utility to join classnames together. Falsy values are filtered away.
 * Similar to `cx()` in Linaria but with this we don't have to make Linaria (or any other runtime library for this) as a dependency
 *
 * https://github.com/callstack/linaria/blob/master/packages/core/src/cx.ts
 */
export const classnames = (...classNames) => {
    return classNames.filter(Boolean).join(' ');
};
